import React, { useEffect, useState } from 'react';
import { CUSTOMER_COMPANY_INFO_ENDPOINT } from '../../utils/api';
import { toast } from 'react-hot-toast';

import CustomerNavbar from '../../components/layout/CustomerNavbar';
import CustomerSidebar from '../../components/layout/CustomerSidebar';

function Company() {
  const [company, setCompany] = useState(null);

  useEffect(() => {
    fetchCompany();
  }, []);

  const fetchCompany = async () => {
    try {
      console.log('📡 API Endpoint:', CUSTOMER_COMPANY_INFO_ENDPOINT);

      const rawToken = localStorage.getItem('token');
      if (!rawToken) {
        toast.error('No login token found');
        return;
      }

      let decoded;
      try {
        decoded = JSON.parse(atob(rawToken));
        console.log('✅ Decoded token:', decoded);
      } catch (decodeErr) {
        console.error('❌ Token decode error:', decodeErr);
        toast.error('Invalid or corrupted token format');
        return;
      }

      const { customer_id, customer_token } = decoded;
      if (!customer_id || !customer_token) {
        toast.error('Invalid token structure');
        return;
      }

      console.log('📤 About to send fetch call...');

      const response = await fetch(CUSTOMER_COMPANY_INFO_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customer_id,
          customer_token
        })
      });

      console.log('✅ Fetch response received');
      const res = await response.json();
      console.log('📥 API Response:', res);

      if (res.success) {
        setCompany(res.company);
      } else {
        toast.error(res.message || 'Failed to load company data');
      }
    } catch (err) {
      console.error('❌ Fetch error while calling company API:', err);
      toast.error('API call failed. See console for details.');
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <CustomerNavbar />

      <div className="d-flex flex-grow-1">
        <CustomerSidebar />

        <div className="container-fluid mt-4">
          <h4 className="mb-4">🏢 Company Profile</h4>

          {company ? (
            <div className="card shadow-sm border-0">
              <div className="card-body">
                <p><strong>Company Name:</strong> {company.name}</p>
                <p><strong>Address:</strong> {company.address}</p>
                <p><strong>City:</strong> {company.city}</p>
                <p><strong>State:</strong> {company.state}</p>
                <p><strong>Pincode:</strong> {company.pincode}</p>
                <p><strong>GST No:</strong> {company.gst_no}</p>
                <p><strong>PAN No:</strong> {company.pan_no}</p>
              </div>
            </div>
          ) : (
            <p>Loading company data...</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Company;
